import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { BrowserRouter, Switch, Route } from 'react-router-dom';

import { zeraerrornetwork } from '../actions/tokens/actiontokencidtechapi';
import CongressoNavegacao from './modulos/congresso/CongressoNavegacao';
import CredenciamentoNavegacao from './modulos/credenciamento/CredenciamentoNavegacao';
import GerenciamentoNavegacao from './modulos/gerenciamento/GerenciamentoNavegacao';
import ProdutoEventoNavegacao from './modulos/produtoEvento/ProdutoEventoNavegacao';
import TerminaisNavegacao from './modulos/terminais/TerminaisNavegacao';
import PagamentosNavegacao from './modulos/pagamentos/PagamentosNavegacao';
import { removeToken } from '../utils/tokencidtechapi';

window.Pusher = require('pusher-js');

const Navegacoes = (props) => {
    
    const {netWorkErrors,zeraerrornetwork} = props;
        
    async function load () {                
        //TOKEN VENCIDO
        if(netWorkErrors && netWorkErrors.status === 401){
            zeraerrornetwork();
        }
    }

    useEffect(() => {
        load();
    },[])

    useEffect(() => {
        if(netWorkErrors && netWorkErrors.status === 401){
            removeToken();
            zeraerrornetwork();
            load();
        }
    },[netWorkErrors]);
        
    return (        
        <BrowserRouter basename='app'>
            <Switch>
                <Route path="/credenciamento" component={CredenciamentoNavegacao} />
                <Route path="/terminais" component={TerminaisNavegacao} />
                <Route path="/congresso" component={CongressoNavegacao} />
                <Route path="/gerenciamento" component={GerenciamentoNavegacao} />
                <Route path="/produtoEvento" component={ProdutoEventoNavegacao} />
                <Route path="/pagamentos" component={PagamentosNavegacao} />
            </Switch>
        </BrowserRouter>        
    )    
}

const mapStateToProps = (state) => {
    return {
        reducerToken: state.reducerToken,
        netWorkErrors: state.reducerNetWorkErrors
    }
}

export default connect(mapStateToProps,{zeraerrornetwork})(Navegacoes);